export const SHOPPING_LIST_INITIALIZE_LIST = 'SHOPPING_LIST_INITIALIZE_LIST'
export const SHOPPING_LIST_CREATE_LIST = 'SHOPPING_LIST_CREATE_LIST'
export const SHOPPING_LIST_UPDATE_LIST = 'SHOPPING_LIST_UPDATE_LIST'
export const SHOPPING_LIST_CREATE_ITEM = 'SHOPPING_LIST_CREATE_ITEM'
export const SHOPPING_LIST_EDIT_ITEM = 'SHOPPING_LIST_EDIT_ITEM'
export const SHOPPING_LIST_DELETE_ITEM = 'SHOPPING_LIST_DELETE_ITEM'
export const SHOPPING_LIST_CLEAR_ITEMS = 'SHOPPING_LIST_CLEAR_ITEMS'
